import React from 'react';
import { Checkbox } from 'antd';
import { connect } from 'react-redux';
import { contact } from '../../../../models/entities/businessPartner/contact';
import { singleBusinessPartnersSelectors } from '../../../../state/ducks/singleBusinessPartner/selectors';
import { RootState } from '../../../../state/store/store';

type Props = {
    contact: contact;
    businessPartnerId?: string;
    updateBusinessPartnerContact: (businessPartnerId: string, contact: contact) => Promise<number>;
};

const ReceiveFinancialDocumentsCellRenderer = ({
    contact,
    businessPartnerId,
    updateBusinessPartnerContact
}: Props) => (
    <div onClick={(e) => e.stopPropagation()}>
        <Checkbox
            checked={!!contact.receiveFinancialDocuments}
            onChange={(e) => {
                if (!businessPartnerId || !contact.id) return;
                void updateBusinessPartnerContact(businessPartnerId, {
                    ...contact,
                    receiveFinancialDocuments: e.target.checked
                });
            }}
        />
    </div>
);

const mapStateToProps = (state: RootState) => ({
    businessPartnerId: singleBusinessPartnersSelectors.businessPartner(state)?.id
});

const mapDispatchToProps = (dispatch: any) => ({
    updateBusinessPartnerContact: (businessPartnerId: string, contactPayload: contact) =>
        dispatch.businessPartners.updateBusinessPartnerContact({ businessPartnerId, contact: contactPayload })
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveFinancialDocumentsCellRenderer);
